import React from 'react';
import moment from 'jalali-moment';

/*
    - ihoDesignSystem
*/
import { Box, Button, Calendar, Grid, Image, Modal, Select, TextField } from '@iho-design-system/Loader';

/*
    - svg
*/
import SearchSVG from '../../assets/images/icons/search.svg';
import CalendarSVG from '../../assets/images/icons/calendar-blue.svg';
import CloseSVG from '../../assets/images/icons/close.svg';

const Toolbar = ({ requestIdSearchProps, advancedSearchProps, reloadRequestProps }) => {

    /*
        - defaultData
    */
    const [requestIdSearchKey, setRequestIdSearchKey] = React.useState({
        value: '',
        color: 'gray'
    });
    const [advancedSearchData, setAdvancedsearchData] = React.useState({
        RequestKey: -1,
        TicketStatus: -1
    });
    const [advancedSearchDate, setAdvancedSearchDate] = React.useState('');

    /*
        - reserveIdSearchHandler
    */
    const requestIdSearchKeyHandler = (value) => {
        if (/^[\u06F0-\u06F90-9]+$/.test(value) || value.length === 0) {
            setRequestIdSearchKey({
                value: value,
                color: 'gray'
            });
        } else {
            setRequestIdSearchKey({
                value: value,
                color: 'danger'
            });
        }
    }

    /*
        - reserveIdSearchProps
    */
    const requestIdSearch = () => {
        requestIdSearchProps(requestIdSearchKey.value)
    }

    /*
        - advancedSearchHandler
    */
    const advancedSearchHandler = (key, value) => {
        if (key === 'requestKey') {
            setAdvancedsearchData({
                ...advancedSearchData,
                RequestKey: value
            });
        }
        if (key === 'ticketStatus') {
            setAdvancedsearchData({
                ...advancedSearchData,
                TicketStatus: value
            });
        }
    }

    /*
        - advancedSearchProps
    */
    const advancedSearch = () => {
        advancedSearchData.AddDate = (advancedSearchDate !== '') ? moment.from(advancedSearchDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : '';
        advancedSearchProps(advancedSearchData);
        closeModal('searchModal');
    }

    /*
        - toggleCaldendar
    */
    const toggleCalendar = (event, calendar) => {
        if (event.target.tagName === 'INPUT' && calendar === 'advancedSearchDate') {
            setAdvancedSearchDate('')
        }
        if (event.target.tagName === 'DIV' || event.target.tagName === 'INPUT') {
            document.querySelector(`.${calendar}`).classList.toggle('d-none');
        }
    }

    /*
        - clearDate
    */
    const clearDate = () => {
        setAdvancedSearchDate('');
    }

    /*
        - unsetFilter
    */
    const unsetFilter = () => {
        setRequestIdSearchKey({
            value: '',
            color: 'gray'
        });
        setAdvancedsearchData({
            RequestKey: -1,
            TicketStatus: -1
        });
        setAdvancedSearchDate('');
        reloadRequestProps(Math.floor(Math.random() * 100));
    }

    /*
        - searchBoxToggle
    */
    const searchBoxToggle = (event) => {
        let slideUp = event.target.closest('.parent-class').querySelector('.slide-up');
        let slideDown = event.target.closest('.parent-class').querySelector('.slide-down');
        document.querySelector('.unsetFilter').classList.toggle('d-none');
        if (slideUp) {
            slideUp.classList.add(`slide-down`);
            slideUp.classList.remove(`slide-up`);
        } else {
            slideDown.classList.add(`slide-up`);
            slideDown.classList.remove(`slide-down`);
        }
    }

    /*
        - modal
    */
    const openModal = (modal) => {
        document.querySelector(`.${modal}`).classList.remove('d-none');
    }

    const closeModal = (modal) => {
        document.querySelector(`.${modal}`).classList.add('d-none');
    }

    /*
        - scale
    */
    const screenWidth = window.innerWidth;
    let scale = '';
    if (screenWidth > 1400) {
        scale = 'xx-large';
    } else if (screenWidth <= 1400 && screenWidth > 1200) {
        scale = 'x-large';
    } else if (screenWidth <= 1200 && screenWidth > 992) {
        scale = 'large'
    } else if (screenWidth <= 992 && screenWidth > 768) {
        scale = 'medium'
    } else if (screenWidth <= 768 && screenWidth > 576) {
        scale = 'small'
    } else if (screenWidth <= 576) {
        scale = 'x-small'
    }

    return (
        <React.Fragment>
            <Box
                className={`parent-class`}>
                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item
                            className={`position-relative`}
                            size='col-8 md-4'>
                            <TextField
                                onChange={requestIdSearchKeyHandler}
                                placeholder='کد درخواست یا کد پیگیری رزرو'
                                value={requestIdSearchKey.value} />
                            {requestIdSearchKey.color === 'gray' &&
                                <Button
                                    onClick={requestIdSearch}
                                    variant='light'
                                    color='primary'
                                    size='sm'
                                    ms={{
                                        position: 'absolute',
                                        top: '12px',
                                        left: '12px',
                                    }}>
                                    <Image
                                        src={SearchSVG} />
                                </Button>
                            }
                            {requestIdSearchKey.color === 'danger' &&
                                <Button
                                    variant='light'
                                    color='danger'
                                    size='sm'
                                    ms={{
                                        position: 'absolute',
                                        top: '12px',
                                        left: '12px',
                                    }}>
                                    <Image
                                        src={SearchSVG} />
                                </Button>
                            }
                        </Grid.Item>
                        <Grid.Item
                            className={`text-left`}
                            size='col-4 md-8'>
                            {(scale === 'xx-large' || scale === 'x-large' || scale === 'large' || scale === 'medium' || scale === 'small') &&
                                <React.Fragment>
                                    <Button
                                        onClick={unsetFilter}
                                        className={`unsetFilter d-none mx-sm mr-0`}
                                        color='danger'>
                                        حذف فیلترها
                                    </Button>
                                    <Button
                                        onClick={(event) => searchBoxToggle(event)}
                                        color='primary'>
                                        جستجوی پیشرفته
                                    </Button>
                                </React.Fragment>
                            }
                            {(scale === 'x-small' || scale === 'x-small') &&
                                <Button
                                    onClick={() => openModal('searchModal')}
                                    color='primary'>
                                    فیلترها
                                </Button>
                            }
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
                <Grid>
                    <Grid.Wrapper
                        className={`slide-up`}>
                        <Grid.Item
                            size='col-3'>
                            <Select
                                onChange={(value) => advancedSearchHandler('requestKey', value)}
                                label='نوع درخواست'
                                init={advancedSearchData.RequestKey}
                                readonly>
                                <Select.Item
                                    value='-1'>
                                    همه درخواست‌ها
                                </Select.Item>
                                <Select.Item
                                    value='0'>
                                    تغییر یا حذف اتاق
                                </Select.Item>
                                <Select.Item
                                    value='1'>
                                    کنسل کردن رزرو
                                </Select.Item>
                                <Select.Item
                                    value='2'>
                                    تغییر تاریخ رزرو
                                </Select.Item>
                                <Select.Item
                                    value='3'>
                                    افزودن نفر اضافه
                                </Select.Item>
                                <Select.Item
                                    value='4'>
                                    افزودن نیم شارژ
                                </Select.Item>
                                <Select.Item
                                    value='6'>
                                    تغییر  اطلاعات مسافران
                                </Select.Item>
                                <Select.Item
                                    value='8'>
                                    ترنسفر
                                </Select.Item>
                            </Select>
                        </Grid.Item>
                        <Grid.Item
                            size='col-3'>
                            <Select
                                onChange={(value) => advancedSearchHandler('ticketStatus', value)}
                                label='وضعیت'
                                init={advancedSearchData.TicketStatus}
                                readonly>
                                <Select.Item
                                    value='-1'>
                                    همه وضعیت ها
                                </Select.Item>
                                <Select.Item
                                    value='0'>
                                    در انتظار بررسی
                                </Select.Item>
                                <Select.Item
                                    value='2'>
                                    در حال بررسی
                                </Select.Item>
                                <Select.Item
                                    value='1'>
                                    پاسخ داده شده
                                </Select.Item>
                                <Select.Item
                                    value='Canceled'>
                                    لغو شده
                                </Select.Item>
                            </Select>
                        </Grid.Item>
                        <Grid.Item
                            className={`position-relative`}
                            size='col-3'>
                            <Box
                                onClick={(event) => toggleCalendar(event, 'advancedSearchDate')}>
                                <TextField
                                    label='تاریخ ثبت'
                                    value={advancedSearchDate}
                                    placeholder='روز/ماه/سال'
                                    ms={{
                                        'input': {
                                            paddingRight: '35px'
                                        }
                                    }} />
                                <Image
                                    className={`pointer position-absolute`}
                                    src={CalendarSVG}
                                    ms={{
                                        width: '16px',
                                        height: '16px',
                                        top: '47px',
                                        right: '20px'
                                    }} />
                                {advancedSearchDate !== '' &&
                                    <Image
                                        onClick={clearDate}
                                        className={`pointer position-absolute`}
                                        src={CloseSVG}
                                        ms={{
                                            width: '16px',
                                            height: '16px',
                                            top: '47px',
                                            left: '20px'
                                        }} />
                                }
                                <Box
                                    className={`advancedSearchDate d-none position-absolute`}
                                    ms={{
                                        width: '320px',
                                        top: 'calc(75px + var(--sizing-xs))',
                                        zIndex: '1'
                                    }}>
                                    <Calendar
                                        onChange={event => setAdvancedSearchDate(event)} />
                                </Box>
                            </Box>
                        </Grid.Item>
                        <Grid.Item
                            size='col-3'>
                            <Button
                                onClick={advancedSearch}
                                variant='filled'
                                color='primary'
                                ms={{
                                    marginTop: '28px',
                                    float: 'left'
                                }}>
                                جستجو
                            </Button>
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
            </Box>
            <Modal
                className={`searchModal`}>
                <Modal.Wrapper
                    size='xs'
                    ms={{
                        '@media(min-width:576px)': {
                            width: '360px !important'
                        },
                        '@media(max-width:576px)': {
                            width: 'calc(100% - 12px) !important'
                        }
                    }}>
                    <Modal.Header>
                        <Box />
                    </Modal.Header>
                    <Grid>
                        <Grid.Wrapper>
                            <Grid.Item
                                size='col-12'>
                                <Select
                                    onChange={(value) => advancedSearchHandler('requestKey', value)}
                                    placeholder='نوع درخواست'
                                    init={advancedSearchData.RequestKey}
                                    readonly>
                                    <Select.Item
                                        value='-1'>
                                        همه درخواست‌ها
                                    </Select.Item>
                                    <Select.Item
                                        value='0'>
                                        تغییر یا حذف اتاق
                                    </Select.Item>
                                    <Select.Item
                                        value='1'>
                                        کنسل کردن رزرو
                                    </Select.Item>
                                    <Select.Item
                                        value='2'>
                                        تغییر تاریخ رزرو
                                    </Select.Item>
                                    <Select.Item
                                        value='3'>
                                        افزودن نفر اضافه
                                    </Select.Item>
                                    <Select.Item
                                        value='4'>
                                        افزودن نیم شارژ
                                    </Select.Item>
                                    <Select.Item
                                        value='6'>
                                        تغییر  اطلاعات مسافران
                                    </Select.Item>
                                    <Select.Item
                                        value='8'>
                                        ترنسفر
                                    </Select.Item>
                                </Select>
                            </Grid.Item>
                            <Grid.Item
                                size='col-12'>
                                <Select
                                    onChange={(value) => advancedSearchHandler('ticketStatus', value)}
                                    placeholder='وضعیت'
                                    init={advancedSearchData.TicketStatus}
                                    readonly>
                                    <Select.Item
                                        value='-1'>
                                        همه وضعیت ها
                                    </Select.Item>
                                    <Select.Item
                                        value=''>
                                        در انتظار بررسی
                                    </Select.Item>
                                    <Select.Item
                                        value=''>
                                        در حال بررسی
                                    </Select.Item>
                                    <Select.Item
                                        value=''>
                                        انجام شده
                                    </Select.Item>
                                    <Select.Item
                                        value=''>
                                        لغو شده
                                    </Select.Item>
                                </Select>
                            </Grid.Item>
                            <Grid.Item
                                className={`position-relative`}
                                size='col-12'>
                                <Box
                                    onClick={(event) => toggleCalendar(event, 'advancedSearchDateMobile')}>
                                    <TextField
                                        value={advancedSearchDate}
                                        placeholder='تاریخ ثبت'
                                        ms={{
                                            'input': {
                                                paddingRight: '35px'
                                            }
                                        }} />
                                    <Image
                                        className={`pointer position-absolute`}
                                        src={CalendarSVG}
                                        ms={{
                                            width: '16px',
                                            height: '16px',
                                            top: '20px',
                                            right: '20px'
                                        }} />
                                    {advancedSearchDate !== '' &&
                                        <Image
                                            onClick={clearDate}
                                            className={`pointer position-absolute`}
                                            src={CloseSVG}
                                            ms={{
                                                width: '16px',
                                                height: '16px',
                                                top: '20px',
                                                left: '20px'
                                            }} />
                                    }
                                    <Box
                                        className={`advancedSearchDateMobile d-none position-absolute`}
                                        ms={{
                                            width: '260px',
                                            transform: 'translate(-50%, -50%)',
                                            top: '50%',
                                            left: '50%',
                                            zIndex: '1'
                                        }}>
                                        <Calendar
                                            onChange={event => setAdvancedSearchDate(event)} />
                                    </Box>
                                </Box>
                            </Grid.Item>
                            <Grid.Item
                                size='col-7'>
                                <Button
                                    onClick={advancedSearch}
                                    className={`w-100`}
                                    variant='filled'
                                    color='primary'>
                                    جستجو
                                </Button>
                            </Grid.Item>
                            <Grid.Item
                                size='col-5'>
                                <Button
                                    onClick={unsetFilter}
                                    className={`w-100`}
                                    variant='outlined'
                                    color='danger'>
                                    حذف فیلترها
                                </Button>
                            </Grid.Item>
                        </Grid.Wrapper>
                    </Grid>
                </Modal.Wrapper>
            </Modal>
        </React.Fragment >
    );

}

export default Toolbar;